'use client';
import '@vtmn-play/css/component/VpLoader.css';

import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { mergeProps } from '@vtmn-play/utils';
import { useVpLoader } from './useVpLoader.mjs';

const VpLoader = forwardRef((props, ref) => {
  const { api, spreadableProps } = useVpLoader(props);
  return /* @__PURE__ */ jsx("span", { ...mergeProps(api.getRootProps(), spreadableProps), ref });
});

export { VpLoader };
